module.exports = __webpack_public_path__ + "media/phase2.9fcfe661.webm";